module.exports = __webpack_public_path__ + "static/media/logoq-primary.68059829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoq-primary.png
// module id = 137
// module chunks = 0